import Syllabic from "./SyllabicValue.js";

let phone = {
  a: "あ",
  i: "い",
  u: "う",
  e: "え",
  k: "く",
  ka: "か",
  ki: "き",
  ku: "く",
  ke: "け",
  g: "ぐ",
  ga: "が",
  gi: "ぎ",
  gu: "ぐ",
  ge: "げ",
  q: "く",
  qa: "か",
  qi: "き",
  qu: "く",
  qe: "け",
  s: "す",
  sa: "さ",
  si: "すぃ",
  su: "す",
  se: "せ",
  z: "ず",
  za: "ざ",
  zi: "ずぃ",
  zu: "ず",
  ze: "ぜ",
  š: "しゅ",
  ša: "しゃ",
  ši: "し",
  šu: "しゅ",
  še: "しぇ",
  ṣ: "つ",
  ṣa: "つぁ",
  ṣi: "つぃ",
  ṣu: "つ",
  ṣe: "つぇ",
  t: "と",
  ta: "た",
  ti: "てぃ",
  tu: "とぅ",
  te: "て",
  ṭ: "と",
  ṭa: "た",
  ṭi: "てぃ",
  ṭu: "とぅ",
  ṭe: "て",
  d: "ど",
  da: "だ",
  di: "でぃ",
  du: "どぅ",
  de: "で",
  n: "ん",
  na: "な",
  ni: "に",
  nu: "ぬ",
  ne: "ね",
  h: "は",
  ha: "は",
  hi: "ひ",
  hu: "ふ",
  he: "へ",
  b: "ぶ",
  ba: "ば",
  bi: "び",
  bu: "ぶ",
  be: "べ",
  p: "ぷ",
  pa: "ぱ",
  pi: "ぴ",
  pu: "ぷ",
  pe: "ぺ",
  m: "む",
  ma: "ま",
  mi: "み",
  mu: "む",
  me: "め",
  r: "る",
  ra: "ら",
  ri: "り",
  ru: "る",
  re: "れ",
  l: "る",
  la: "ら",
  li: "り",
  lu: "る",
  le: "れ",
  y: "い",
  ya: "や",
  yi: "い",
  yu: "ゆ",
  ye: "いぇ",
  w: "う",
  wa: "わ",
  wi: "うぃ",
  wu: "う",
  we: "うぇ"
};

function kananaize(str, useAccent) {
  var str2 = str.toLowerCase();
  if (str.match(/(^[0-9/]+)/)) return str;
  str2 = str2.replace(/[0-9x]+$/, "");
  if (str.search(/[\s{}.]/) >= 0) return Syllabic(str, useAccent);

  str2 = str2.replace("ḫ", "h");
  var str3 = str2.replace(
    /[kgqszšṣtṭdnhbpmrlyw][aieu]/g,
    match => phone[match]
  );

  str3 = str3.replace(/sh/, "しゅ");

  var str4 = str3.replace(/[kgqszšṣtṭdnhbpmrlyw]/g, match => phone[match]);

  var str5 = str4.replace(/[aieu]/g, match => phone[match]);

  return str5;
}

export default kananaize;
